export default function getFirstUrl(url) {
  if (typeof url !== 'string') {
    return '';
  }
  return url.split('/').filter((x) => x)[0];
}
